document.addEventListener('DOMContentLoaded', function() {
    var skuContainer = document.querySelector('.product__sku'); // Adjust this to select the container
    var skuValue = document.querySelector('.product__sku__value'); // For updating the text content

    function getSKUById(products) {
        const id = ShopifyAnalytics.meta.selectedVariantId;
        const product = products.find(function(item) {
            return item.id == id;
        });
        if (product && !product?.sku) {
          console.log('Product was found but SKU was not', product);
        }
        return product ? product?.sku : null;
    }

    function refreshSku() {
        var sku = getSKUById(ShopifyAnalytics.meta.product.variants);
        if (sku) {
            skuValue.textContent = sku;
            skuContainer.style.display = ''; // Show the container only when SKU is available
            clearInterval(checkDataLoaded);
        } else {
            console.log('No SKU found for given ID');
            skuContainer.style.display = 'none'; // Keep the container hidden
        }
    }

    var checkDataLoaded = setTimeout(refreshSku, 1000);

    document.querySelectorAll('variant-selects').forEach(function(radio) {
        radio.addEventListener('change', function() {
            setTimeout(refreshSku, 200); // Delay of 200 milliseconds
        });
    });
});
